import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, Transition as _Transition, createSlots as _createSlots, withModifiers as _withModifiers, vModelRadio as _vModelRadio, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-66c1b41b")

_pushScopeId("data-v-66c1b41b")
const _hoisted_1 = {
  key: 0,
  class: "container regular-container",
  id: "product-page"
}
const _hoisted_2 = { class: "page-header-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_6 = { class: "card" }
const _hoisted_7 = {
  class: "card-header collapsed",
  id: "headingProductDetails",
  "data-toggle": "collapse",
  "data-target": "#productDetails"
}
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productDetails"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_11 = {
  id: "productDetails",
  class: "collapse",
  "aria-labelledby": "headingProductDetails",
  "data-parent": "#accordionExample"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  class: "several-section",
  style: {"position":"relative"}
}
const _hoisted_14 = { class: "edit-mode row mx-auto" }
const _hoisted_15 = { class: "col-12 col-lg-6 row edit-mode-row" }
const _hoisted_16 = { class: "col-10 title-wrapper" }
const _hoisted_17 = { class: "product-title" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_23 = { class: "input-text-length" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("/30 ")
const _hoisted_25 = { class: "col-12 col-lg-6 row edit-mode-row" }
const _hoisted_26 = { class: "col-10 title-wrapper mb-0" }
const _hoisted_27 = { class: "product-title" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_30 = {
  class: "col-12",
  style: {"top":"8px"}
}
const _hoisted_31 = { class: "invalid-feedback" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_33 = { class: "input-text-length" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("/120 ")
const _hoisted_35 = { class: "col-12 row edit-mode-row" }
const _hoisted_36 = { class: "col-10 title-wrapper" }
const _hoisted_37 = { class: "product-title" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_40 = { class: "col-12" }
const _hoisted_41 = { class: "invalid-feedback" }
const _hoisted_42 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_43 = { class: "input-text-length" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("/1200 ")
const _hoisted_45 = { class: "col-12 row edit-mode-row" }
const _hoisted_46 = { class: "col-10 title-wrapper" }
const _hoisted_47 = { class: "product-title" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_50 = { class: "col-12" }
const _hoisted_51 = { class: "invalid-feedback" }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_53 = { class: "input-text-length" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("/1200 ")
const _hoisted_55 = { class: "several-section" }
const _hoisted_56 = { class: "edit-mode row mx-auto" }
const _hoisted_57 = { class: "col-12 row edit-mode-row" }
const _hoisted_58 = { class: "col-10 title-wrapper" }
const _hoisted_59 = { class: "product-title" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_61 = { class: "invalid-feedback" }
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_63 = { class: "col-2" }
const _hoisted_64 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_65 = { class: "col-12" }
const _hoisted_66 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_67 = { class: "marker-text" }
const _hoisted_68 = { class: "several-section" }
const _hoisted_69 = { class: "edit-mode row mx-auto" }
const _hoisted_70 = { class: "col-12 row edit-mode-row" }
const _hoisted_71 = { class: "col-10 title-wrapper" }
const _hoisted_72 = { class: "product-title" }
const _hoisted_73 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_74 = { class: "col-12 col-lg-6" }
const _hoisted_75 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_76 = {
  key: 0,
  class: "multy-invalid-feedback"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_79 = { class: "col-12 row edit-mode-row" }
const _hoisted_80 = { class: "col-10 title-wrapper" }
const _hoisted_81 = { class: "product-title" }
const _hoisted_82 = { class: "col-2" }
const _hoisted_83 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_84 = { class: "col-12" }
const _hoisted_85 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_86 = { class: "marker-text" }
const _hoisted_87 = { class: "several-section" }
const _hoisted_88 = { class: "edit-mode row mx-auto" }
const _hoisted_89 = { class: "col-12 row edit-mode-row" }
const _hoisted_90 = { class: "col-10 title-wrapper" }
const _hoisted_91 = { class: "product-title" }
const _hoisted_92 = { class: "col-2" }
const _hoisted_93 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_94 = { class: "col-12" }
const _hoisted_95 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_96 = { class: "marker-text" }
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_98 = { class: "col-12 row edit-mode-row" }
const _hoisted_99 = { class: "col-10 title-wrapper" }
const _hoisted_100 = { class: "product-title" }
const _hoisted_101 = { class: "col-2" }
const _hoisted_102 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_103 = { class: "col-12" }
const _hoisted_104 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_105 = { class: "marker-text" }
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_107 = { class: "col-12 row edit-mode-row" }
const _hoisted_108 = { class: "col-10 title-wrapper" }
const _hoisted_109 = { class: "product-title" }
const _hoisted_110 = { class: "col-2" }
const _hoisted_111 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_112 = { class: "col-12" }
const _hoisted_113 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_114 = { class: "marker-text" }
const _hoisted_115 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_116 = { class: "col-12 row edit-mode-row" }
const _hoisted_117 = { class: "col-10 title-wrapper" }
const _hoisted_118 = { class: "product-title" }
const _hoisted_119 = { class: "col-2" }
const _hoisted_120 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_121 = { class: "col-12" }
const _hoisted_122 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_123 = { class: "marker-text" }
const _hoisted_124 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_125 = { class: "col-12 row edit-mode-row" }
const _hoisted_126 = { class: "col-10 title-wrapper" }
const _hoisted_127 = { class: "product-title" }
const _hoisted_128 = { class: "col-2" }
const _hoisted_129 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_130 = { class: "col-12" }
const _hoisted_131 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_132 = { class: "marker-text" }
const _hoisted_133 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_134 = { class: "col-12 row edit-mode-row" }
const _hoisted_135 = { class: "col-10 title-wrapper" }
const _hoisted_136 = { class: "product-title" }
const _hoisted_137 = { class: "col-2" }
const _hoisted_138 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_139 = { class: "col-12" }
const _hoisted_140 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_141 = { class: "marker-text" }
const _hoisted_142 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_143 = { class: "col-12 row edit-mode-row" }
const _hoisted_144 = { class: "col-10 title-wrapper" }
const _hoisted_145 = { class: "product-title" }
const _hoisted_146 = { class: "col-2" }
const _hoisted_147 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_148 = { class: "col-12" }
const _hoisted_149 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_150 = { class: "marker-text" }
const _hoisted_151 = { class: "several-section" }
const _hoisted_152 = { class: "edit-mode row mx-auto" }
const _hoisted_153 = { class: "col-12 row edit-mode-row" }
const _hoisted_154 = { class: "col-10 title-wrapper" }
const _hoisted_155 = { class: "product-title" }
const _hoisted_156 = { class: "col-2" }
const _hoisted_157 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_158 = { class: "col-12" }
const _hoisted_159 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_160 = { class: "marker-text" }
const _hoisted_161 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_162 = { class: "col-12 row edit-mode-row" }
const _hoisted_163 = { class: "col-10 title-wrapper" }
const _hoisted_164 = { class: "product-title" }
const _hoisted_165 = { class: "col-2" }
const _hoisted_166 = /*#__PURE__*/_createVNode("span", { class: "icon dark-squared-plus" }, null, -1)
const _hoisted_167 = { class: "col-12" }
const _hoisted_168 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_169 = { class: "marker-text" }
const _hoisted_170 = { class: "several-section" }
const _hoisted_171 = { class: "edit-mode row mx-auto averageDuration" }
const _hoisted_172 = { class: "col-lg-5 col-12" }
const _hoisted_173 = { class: "product-title" }
const _hoisted_174 = { class: "several-section" }
const _hoisted_175 = { style: {"position":"relative"} }
const _hoisted_176 = {
  key: 0,
  class: "mandatory-warning-info extraInfo-warning"
}
const _hoisted_177 = { class: "warning-info-text" }
const _hoisted_178 = { class: "edit-mode row mx-auto extraInfo" }
const _hoisted_179 = { class: "col-12" }
const _hoisted_180 = { class: "d-flex" }
const _hoisted_181 = { class: "product-title" }
const _hoisted_182 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_183 = { class: "t-right" }
const _hoisted_184 = { class: "input-text-length" }
const _hoisted_185 = /*#__PURE__*/_createTextVNode("/255 ")
const _hoisted_186 = { class: "several-section" }
const _hoisted_187 = { class: "col-lg-6 col-12" }
const _hoisted_188 = { class: "receiveNotifications-block" }
const _hoisted_189 = { class: "receiveNotifications-block__title" }
const _hoisted_190 = { class: "card collapsed" }
const _hoisted_191 = {
  class: "card-header collapsed",
  id: "headingproductAddress",
  "data-toggle": "collapse",
  "data-target": "#productAddress"
}
const _hoisted_192 = { class: "mb-0" }
const _hoisted_193 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productAddress"
}
const _hoisted_194 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_195 = {
  id: "productAddress",
  class: "collapse",
  "aria-labelledby": "headingproductAddress",
  "data-parent": "#accordionExample"
}
const _hoisted_196 = { class: "card-body" }
const _hoisted_197 = {
  class: "several-section",
  style: {"z-index":"1"}
}
const _hoisted_198 = { class: "edit-mode row" }
const _hoisted_199 = {
  class: "col-12",
  style: {"margin-bottom":"8px"}
}
const _hoisted_200 = { class: "title-wrapper" }
const _hoisted_201 = { class: "product-title" }
const _hoisted_202 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_203 = { class: "col-12 product-property-form-control" }
const _hoisted_204 = /*#__PURE__*/_createVNode("small", {
  class: "form-text",
  style: {"margin-bottom":"20px"}
}, null, -1)
const _hoisted_205 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-location fs-20 browse-icon" }, null, -1)
const _hoisted_206 = {
  key: 0,
  class: "col-12 col-lg-6",
  style: {"margin-bottom":"20px"}
}
const _hoisted_207 = {
  ref: "map",
  id: "map"
}
const _hoisted_208 = { class: "col-12 col-lg-6 mb-0" }
const _hoisted_209 = { class: "row" }
const _hoisted_210 = { class: "col-10 title-wrapper" }
const _hoisted_211 = { class: "product-title" }
const _hoisted_212 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_213 = { class: "col-12 product-property-form-control" }
const _hoisted_214 = { class: "multi-select-block" }
const _hoisted_215 = { class: "invalid-feedback" }
const _hoisted_216 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_217 = /*#__PURE__*/_createVNode("small", {
  class: "form-text",
  style: {"margin-bottom":"20px"}
}, null, -1)
const _hoisted_218 = { class: "col-12 col-lg-6 mb-0" }
const _hoisted_219 = { class: "row" }
const _hoisted_220 = { class: "col-10 title-wrapper" }
const _hoisted_221 = { class: "product-title" }
const _hoisted_222 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_223 = { class: "col-12 product-property-form-control" }
const _hoisted_224 = { class: "multi-select-block" }
const _hoisted_225 = { class: "invalid-feedback" }
const _hoisted_226 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_227 = /*#__PURE__*/_createVNode("small", {
  class: "form-text",
  style: {"margin-bottom":"20px"}
}, null, -1)
const _hoisted_228 = { class: "col-12 row edit-mode-row" }
const _hoisted_229 = { class: "col-10 title-wrapper" }
const _hoisted_230 = { class: "product-title" }
const _hoisted_231 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_232 = { class: "col-12 product-property-form-control" }
const _hoisted_233 = { class: "input-text-length" }
const _hoisted_234 = /*#__PURE__*/_createTextVNode("/300 ")
const _hoisted_235 = { class: "col-12 row edit-mode-row" }
const _hoisted_236 = { class: "col-10 title-wrapper" }
const _hoisted_237 = { class: "product-title" }
const _hoisted_238 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_239 = { class: "col-12 product-property-form-control" }
const _hoisted_240 = { class: "input-text-length" }
const _hoisted_241 = /*#__PURE__*/_createTextVNode("/300 ")
const _hoisted_242 = { class: "card" }
const _hoisted_243 = {
  class: "card-header collapsed",
  id: "headingProductMoreInfo",
  "data-toggle": "collapse",
  "data-target": "#productMoreInfo"
}
const _hoisted_244 = { class: "mb-0" }
const _hoisted_245 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productMoreInfo"
}
const _hoisted_246 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_247 = {
  id: "productMoreInfo",
  class: "collapse",
  "aria-labelledby": "headingProductMoreInfo",
  "data-parent": "#accordionExample"
}
const _hoisted_248 = { class: "card-body" }
const _hoisted_249 = { class: "several-section row mx-auto col-12" }
const _hoisted_250 = { class: "card" }
const _hoisted_251 = {
  class: "card-header collapsed",
  id: "headingProductActivityTimeDuration",
  "data-toggle": "collapse",
  "data-target": "#productActivityTimeDuration"
}
const _hoisted_252 = { class: "mb-0" }
const _hoisted_253 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productActivityTimeDuration"
}
const _hoisted_254 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_255 = {
  id: "productActivityTimeDuration",
  class: "collapse",
  "aria-labelledby": "headingProductActivityTimeDuration",
  "data-parent": "#accordionExample"
}
const _hoisted_256 = { class: "card-body" }
const _hoisted_257 = {
  key: 0,
  class: "several-section p-3"
}
const _hoisted_258 = { class: "form-text small-text" }
const _hoisted_259 = { key: 1 }
const _hoisted_260 = {
  class: "several-section p-relative mb-0",
  style: {"text-align":"center"}
}
const _hoisted_261 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_262 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_263 = { class: "several-section" }
const _hoisted_264 = { class: "card collapsed" }
const _hoisted_265 = {
  class: "card-header collapsed",
  id: "headingProductPhotosVideo",
  "data-toggle": "collapse",
  "data-target": "#productPhotosVideo"
}
const _hoisted_266 = { class: "mb-0" }
const _hoisted_267 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productPhotosVideo"
}
const _hoisted_268 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_269 = {
  id: "productPhotosVideo",
  class: "collapse",
  "aria-labelledby": "headingProductPhotosVideo",
  "data-parent": "#accordionExample"
}
const _hoisted_270 = { class: "card-body" }
const _hoisted_271 = {
  key: 0,
  class: "several-section p-3"
}
const _hoisted_272 = { class: "watch-the-video p-0" }
const _hoisted_273 = {
  target: "_blank",
  href: "https://youtu.be/rGZXf3wb77Y"
}
const _hoisted_274 = { class: "form-text small-text" }
const _hoisted_275 = {
  key: 1,
  class: "p-relative"
}
const _hoisted_276 = {
  class: "several-section",
  style: {"z-index":"1"}
}
const _hoisted_277 = { class: "edit-mode" }
const _hoisted_278 = { class: "row" }
const _hoisted_279 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-add-folder fs-24 browse-icon" }, null, -1)
const _hoisted_280 = { class: "upload-article" }
const _hoisted_281 = { class: "row photo-edit-section" }
const _hoisted_282 = { class: "col" }
const _hoisted_283 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_284 = {
  key: 1,
  class: "row"
}
const _hoisted_285 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_286 = { class: "row" }
const _hoisted_287 = { class: "col-lg-6 col-12" }
const _hoisted_288 = { class: "col-lg-6 col-12" }
const _hoisted_289 = {
  key: 1,
  class: "mx-auto col-12 col-lg-11 images-order"
}
const _hoisted_290 = { class: "col-4 col-md-2 photo-container pointer" }
const _hoisted_291 = {
  key: 0,
  class: "photo-wrapper"
}
const _hoisted_292 = {
  key: 0,
  class: "not-confirmed-label-wrapper"
}
const _hoisted_293 = { class: "warning-info-text" }
const _hoisted_294 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_295 = {
  key: 1,
  class: "span covered"
}
const _hoisted_296 = { tabindex: "-1" }
const _hoisted_297 = { tabindex: "-1" }
const _hoisted_298 = /*#__PURE__*/_createVNode("div", { class: "photo-wrapper" }, [
  /*#__PURE__*/_createVNode("div", { class: "no-photo-wrapper" })
], -1)
const _hoisted_299 = { class: "row photo-edit-section" }
const _hoisted_300 = { class: "col-12" }
const _hoisted_301 = {
  class: "several-section",
  style: {"z-index":"1"}
}
const _hoisted_302 = { class: "edit-mode" }
const _hoisted_303 = {
  key: 0,
  class: "col-12"
}
const _hoisted_304 = { class: "row" }
const _hoisted_305 = { class: "col-10" }
const _hoisted_306 = { class: "tickets-title" }
const _hoisted_307 = { class: "col-2" }
const _hoisted_308 = { class: "row photo-edit-section" }
const _hoisted_309 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto"}
}
const _hoisted_310 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_311 = {
  key: 1,
  class: "row"
}
const _hoisted_312 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_313 = { class: "row" }
const _hoisted_314 = { class: "col-lg-6 col-12" }
const _hoisted_315 = { class: "col-lg-6 col-12" }
const _hoisted_316 = {
  key: 1,
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_317 = { class: "mx-auto col-11 col-lg-11 images-order" }
const _hoisted_318 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_319 = { class: "col-4 col-md-3 photo-container pointer" }
const _hoisted_320 = { class: "photo-wrapper ticket-wrapper" }
const _hoisted_321 = { class: "col-4 col-md-3 photo-container pointer" }
const _hoisted_322 = { class: "photo-wrapper ticket-wrapper" }
const _hoisted_323 = { class: "col-1" }
const _hoisted_324 = /*#__PURE__*/_createVNode("i", {
  class: "icon-f icon-pencil-edit fs-16",
  "data-v-099e29f6": ""
}, null, -1)
const _hoisted_325 = { class: "several-section" }
const _hoisted_326 = { class: "edit-mode" }
const _hoisted_327 = { class: "row mx-auto" }
const _hoisted_328 = { class: "col-12 text-c" }
const _hoisted_329 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_330 = { class: "col-10 title-wrapper title-div" }
const _hoisted_331 = { class: "product-title" }
const _hoisted_332 = { class: "row input-row" }
const _hoisted_333 = { class: "col-10 col-md-11 input-div" }
const _hoisted_334 = { class: "col-2 col-md-1 input-remove-div" }
const _hoisted_335 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_336 = { class: "card" }
const _hoisted_337 = {
  class: "card-header collapsed",
  id: "headingProductDocuments",
  "data-toggle": "collapse",
  "data-target": "#productDocuments"
}
const _hoisted_338 = { class: "mb-0" }
const _hoisted_339 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productDocuments"
}
const _hoisted_340 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_341 = {
  id: "productDocuments",
  class: "collapse",
  "aria-labelledby": "headingProductDocuments",
  "data-parent": "#accordionExample"
}
const _hoisted_342 = { class: "card-body" }
const _hoisted_343 = {
  key: 0,
  class: "several-section p-3"
}
const _hoisted_344 = { class: "form-text small-text" }
const _hoisted_345 = {
  key: 1,
  class: "several-section p-relative"
}
const _hoisted_346 = { class: "edit-mode col-12 col-lg-8 mb-3" }
const _hoisted_347 = { class: "row photo-edit-section" }
const _hoisted_348 = { class: "col" }
const _hoisted_349 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-add-file fs-24 browse-icon" }, null, -1)
const _hoisted_350 = { class: "edit-mode col-12 col-lg-6" }
const _hoisted_351 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_352 = { tabindex: "-1" }
const _hoisted_353 = /*#__PURE__*/_createVNode("div", { class: "photo-wrapper" }, [
  /*#__PURE__*/_createVNode("div", { class: "no-photo-wrapper" })
], -1)
const _hoisted_354 = { class: "card" }
const _hoisted_355 = {
  class: "card-header collapsed",
  id: "headingProductPricing",
  "data-toggle": "collapse",
  "data-target": "#productPricing"
}
const _hoisted_356 = { class: "mb-0" }
const _hoisted_357 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productPricing"
}
const _hoisted_358 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_359 = {
  id: "productPricing",
  class: "collapse",
  "aria-labelledby": "headingProductPricing",
  "data-parent": "#accordionExample"
}
const _hoisted_360 = { class: "card-body" }
const _hoisted_361 = { class: "row" }
const _hoisted_362 = { class: "col-11" }
const _hoisted_363 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_364 = { class: "pricing-row row mx-auto" }
const _hoisted_365 = { class: "col-6 col-lg-3 pricing-name" }
const _hoisted_366 = { class: "product-title" }
const _hoisted_367 = { class: "product-text" }
const _hoisted_368 = { class: "col-6 col-lg-3 pricing-date" }
const _hoisted_369 = { class: "product-title" }
const _hoisted_370 = { class: "product-text" }
const _hoisted_371 = { class: "product-text" }
const _hoisted_372 = { class: "col-5 col-lg-2 p-start-0" }
const _hoisted_373 = { class: "product-title" }
const _hoisted_374 = { class: "product-text" }
const _hoisted_375 = { class: "col-5 col-lg-3 px-0" }
const _hoisted_376 = { class: "product-title" }
const _hoisted_377 = { class: "product-text" }
const _hoisted_378 = { class: "col-2 col-lg-1 pricing-edit text-start text-lg-center" }
const _hoisted_379 = { class: "card" }
const _hoisted_380 = {
  class: "card-header collapsed",
  id: "headingProductFAQ",
  "data-toggle": "collapse",
  "data-target": "#productFAQ"
}
const _hoisted_381 = { class: "mb-0" }
const _hoisted_382 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productFAQ"
}
const _hoisted_383 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_384 = {
  id: "productFAQ",
  class: "collapse",
  "aria-labelledby": "headingProductFAQ",
  "data-parent": "#accordionExample"
}
const _hoisted_385 = { class: "card-body" }
const _hoisted_386 = { class: "several-section row mx-auto col-12" }
const _hoisted_387 = {
  class: "upload-article last-upload-article",
  style: {"width":"100%"}
}
const _hoisted_388 = { class: "m0auto" }
const _hoisted_389 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_390 = {
  key: 0,
  class: "card"
}
const _hoisted_391 = {
  class: "card-header collapsed",
  id: "headingProfiles",
  "data-toggle": "collapse",
  "data-target": "#notoficationsRestrictions"
}
const _hoisted_392 = { class: "mb-0" }
const _hoisted_393 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "notoficationsRestrictions"
}
const _hoisted_394 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_395 = {
  id: "notoficationsRestrictions",
  class: "collapse",
  "aria-labelledby": "notoficationsRestrictions",
  "data-parent": "#accordionExample"
}
const _hoisted_396 = { class: "card-body default-card-body" }
const _hoisted_397 = { class: "several-section" }
const _hoisted_398 = { class: "card" }
const _hoisted_399 = {
  class: "card-header collapsed",
  id: "headingProductGeneral",
  "data-toggle": "collapse",
  "data-target": "#productGeneral"
}
const _hoisted_400 = { class: "mb-0" }
const _hoisted_401 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productGeneral"
}
const _hoisted_402 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_403 = {
  id: "productGeneral",
  class: "collapse",
  "aria-labelledby": "headingProductGeneral",
  "data-parent": "#accordionExample"
}
const _hoisted_404 = { class: "card-body" }
const _hoisted_405 = { class: "several-section row mx-auto" }
const _hoisted_406 = { class: "col-12 col-lg-4" }
const _hoisted_407 = { class: "product-title" }
const _hoisted_408 = { class: "product-text" }
const _hoisted_409 = { class: "col-12 col-lg-4" }
const _hoisted_410 = { class: "product-title" }
const _hoisted_411 = { class: "product-text" }
const _hoisted_412 = { class: "col-12 col-lg-4" }
const _hoisted_413 = { class: "product-title" }
const _hoisted_414 = { class: "product-text text-link" }
const _hoisted_415 = { class: "col-lg-4 col-12 operation-status mt-12" }
const _hoisted_416 = { class: "product-title" }
const _hoisted_417 = { class: "col-12 col-lg-4 mt-12 d-flex" }
const _hoisted_418 = { class: "col-12 col-lg-4 mt-12" }
const _hoisted_419 = { class: "product-title" }
const _hoisted_420 = { class: "col-12 col-lg-4 mt-12" }
const _hoisted_421 = { class: "product-title" }
const _hoisted_422 = { class: "input-text-length" }
const _hoisted_423 = /*#__PURE__*/_createTextVNode("/255 ")
const _hoisted_424 = { class: "col-12 mt-12" }
const _hoisted_425 = { class: "order-limitation-row" }
const _hoisted_426 = { class: "product-title" }
const _hoisted_427 = { class: "product-title" }
const _hoisted_428 = { class: "col-12 edit-mode mt-12 d-flex justify-content-between" }
const _hoisted_429 = { class: "product-title" }
const _hoisted_430 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_431 = { class: "col-12" }
const _hoisted_432 = { class: "input-text-length" }
const _hoisted_433 = /*#__PURE__*/_createTextVNode(" /255 ")
const _hoisted_434 = { class: "toggle-wrapper" }
const _hoisted_435 = { class: "toggle-text" }
const _hoisted_436 = { class: "col-12 change-registration-type" }
const _hoisted_437 = { class: "toggle-wrapper" }
const _hoisted_438 = { class: "toggle-text" }
const _hoisted_439 = { class: "col-12 change-registration-type" }
const _hoisted_440 = { class: "toggle-wrapper" }
const _hoisted_441 = { class: "toggle-text" }
const _hoisted_442 = { class: "col-12 change-registration-type" }
const _hoisted_443 = { class: "toggle-wrapper" }
const _hoisted_444 = { class: "toggle-text" }
const _hoisted_445 = { class: "col-12 change-registration-type" }
const _hoisted_446 = { class: "toggle-wrapper" }
const _hoisted_447 = { class: "toggle-text" }
const _hoisted_448 = { class: "col-12" }
const _hoisted_449 = { class: "toggle-wrapper" }
const _hoisted_450 = { class: "product-title" }
const _hoisted_451 = { class: "col-12 pt20 pb13" }
const _hoisted_452 = { class: "product-title" }
const _hoisted_453 = {
  key: 0,
  class: "col-12"
}
const _hoisted_454 = { class: "d-flex" }
const _hoisted_455 = { class: "orderBlockMinutes-selectType" }
const _hoisted_456 = /*#__PURE__*/_createVNode("div", { class: "col-11 with-border-bottom" }, null, -1)
const _hoisted_457 = { class: "col-12" }
const _hoisted_458 = { class: "row justify-content-between" }
const _hoisted_459 = { class: "form-check product-pricePerPerson col-12 col-md-6" }
const _hoisted_460 = {
  class: "cbx2",
  for: "priceTypePerson",
  tabindex: "12"
}
const _hoisted_461 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_462 = { class: "checkboxtext" }
const _hoisted_463 = { class: "form-text" }
const _hoisted_464 = { class: "form-check product-pricePerPerson col-12 col-md-6" }
const _hoisted_465 = {
  class: "cbx2",
  for: "priceTypeUnit",
  tabindex: "12"
}
const _hoisted_466 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_467 = { class: "checkboxtext" }
const _hoisted_468 = { class: "form-text" }
const _hoisted_469 = { class: "card" }
const _hoisted_470 = {
  class: "card-header collapsed",
  id: "headingProductAboutMe",
  "data-toggle": "collapse",
  "data-target": "#productAboutMe"
}
const _hoisted_471 = { class: "mb-0" }
const _hoisted_472 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productAboutMe"
}
const _hoisted_473 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_474 = {
  id: "productAboutMe",
  class: "collapse",
  "aria-labelledby": "headingProductAboutMe",
  "data-parent": "#accordionExample"
}
const _hoisted_475 = { class: "card-body" }
const _hoisted_476 = { class: "several-section position-relative" }
const _hoisted_477 = { class: "edit-mode about-me-section col-12" }
const _hoisted_478 = {
  key: 0,
  class: "respons-person-image-block"
}
const _hoisted_479 = { class: "d-flex justify-content-evenly" }
const _hoisted_480 = {
  key: 1,
  class: "respons-person-image-block"
}
const _hoisted_481 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-camera fs-38" }, null, -1)
const _hoisted_482 = { class: "edit-mode-row respons-person-name-block" }
const _hoisted_483 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto 16px"}
}
const _hoisted_484 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_485 = {
  key: 1,
  class: "row"
}
const _hoisted_486 = {
  class: "col-12",
  style: {"margin":"0 auto"}
}
const _hoisted_487 = { class: "row" }
const _hoisted_488 = { class: "col-6 text-center" }
const _hoisted_489 = { class: "col-6 text-center" }
const _hoisted_490 = { class: "product-property-form-control" }
const _hoisted_491 = { class: "title-wrapper" }
const _hoisted_492 = { class: "product-title align-top" }
const _hoisted_493 = { class: "input-text-length" }
const _hoisted_494 = { key: 1 }
const _hoisted_495 = /*#__PURE__*/_createTextVNode(" /30 ")
const _hoisted_496 = { class: "edit-mode-row product-property-form-control respons-person-description-block" }
const _hoisted_497 = { class: "title-wrapper d-flex justify-content-between" }
const _hoisted_498 = { class: "product-title" }
const _hoisted_499 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_500 = { class: "input-text-length" }
const _hoisted_501 = { key: 1 }
const _hoisted_502 = /*#__PURE__*/_createTextVNode(" /1200 ")
const _hoisted_503 = { class: "card" }
const _hoisted_504 = {
  class: "card-header collapsed",
  id: "headingProductSellingSettings",
  "data-toggle": "collapse",
  "data-target": "#productSellingSettings"
}
const _hoisted_505 = { class: "mb-0" }
const _hoisted_506 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productSellingSettings"
}
const _hoisted_507 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_508 = {
  id: "productSellingSettings",
  class: "collapse",
  "aria-labelledby": "headingProductSellingSettings",
  "data-parent": "#accordionExample"
}
const _hoisted_509 = { class: "card-body" }
const _hoisted_510 = { class: "several-section row mx-auto col-12" }
const _hoisted_511 = { class: "product-edit-container" }
const _hoisted_512 = /*#__PURE__*/_createVNode("i", { class: "arrow up" }, null, -1)
const _hoisted_513 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_514 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_515 = {
  class: "order-modify-button-wrapper edit-order",
  type: "button"
}
const _hoisted_516 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
const _hoisted_517 = { class: "product-edit-container" }
const _hoisted_518 = /*#__PURE__*/_createVNode("i", { class: "arrow up" }, null, -1)
const _hoisted_519 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_520 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_521 = {
  type: "button",
  class: "order-modify-button-wrapper dark-circle-button"
}
const _hoisted_522 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_523 = {
  class: "order-modify-button-wrapper edit-order",
  type: "submit",
  ref: "submitButtonRef"
}
const _hoisted_524 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_ProductMoreInfo = _resolveComponent("ProductMoreInfo")
  const _component_ProductSlotsTable = _resolveComponent("ProductSlotsTable")
  const _component_cropper = _resolveComponent("cropper")
  const _component_draggable = _resolveComponent("draggable")
  const _component_ProductFAQs = _resolveComponent("ProductFAQs")
  const _component_NotificationsRestrictions = _resolveComponent("NotificationsRestrictions")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_ProductSellingSettings = _resolveComponent("ProductSellingSettings")

  return (_ctx.product && _ctx.showPage)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.product.name || ' '), 1),
        _createVNode("form", {
          onSubmit: _cache[97] || (_cache[97] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
          novalidate: ""
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("h5", _hoisted_8, [
                      _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('product.productDetails')), 1),
                      _hoisted_10
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("div", _hoisted_15, [
                            _createVNode("div", _hoisted_16, [
                              _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('product.productName')), 1),
                              _hoisted_18
                            ]),
                            _createVNode("div", {
                              class: "col-2 pop-up-button",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeToEdit('name')))
                            }, [
                              _hoisted_19
                            ]),
                            _createVNode("div", _hoisted_20, [
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                maxlength: "30",
                                required: "",
                                class: "bookit-input product-input form-control h48",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.product.name = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.product.name]
                              ]),
                              _createVNode("span", _hoisted_21, [
                                _hoisted_22,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                              ]),
                              _createVNode("span", _hoisted_23, [
                                _createVNode("span", {
                                  class: { 'length-limit': _ctx.product.name.length > 29 }
                                }, _toDisplayString(_ctx.product.name.length), 3),
                                _hoisted_24
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_25, [
                            _createVNode("div", _hoisted_26, [
                              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('product.shortDescription')), 1),
                              _hoisted_28
                            ]),
                            _createVNode("div", {
                              class: "col-2 pop-up-button",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.routeToEdit('shortdescription')))
                            }, [
                              _hoisted_29
                            ]),
                            _createVNode("div", _hoisted_30, [
                              _withDirectives(_createVNode("textarea", {
                                name: "textArea",
                                class: "bookit-textarea product-textarea resize-off short-description form-control",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.product.shortDescription = $event)),
                                style: {"max-height":"56px"},
                                maxlength: "120",
                                required: ""
                              }, "\n                          ", 512), [
                                [_vModelText, _ctx.product.shortDescription]
                              ]),
                              _createVNode("span", _hoisted_31, [
                                _hoisted_32,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                              ]),
                              _createVNode("span", _hoisted_33, [
                                _createVNode("span", {
                                  class: { 'length-limit': _ctx.product.shortDescription.length > 119 }
                                }, _toDisplayString(_ctx.product.shortDescription.length), 3),
                                _hoisted_34
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_35, [
                            _createVNode("div", _hoisted_36, [
                              _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('product.longDescription')), 1),
                              _hoisted_38
                            ]),
                            _createVNode("div", {
                              class: "col-2 pop-up-button",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.routeToEdit('fulldescription')))
                            }, [
                              _hoisted_39
                            ]),
                            _createVNode("div", _hoisted_40, [
                              _withDirectives(_createVNode("textarea", {
                                name: "textArea",
                                class: "bookit-textarea product-textarea resize-off long-description form-control",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.product.fullDescription = $event)),
                                maxlength: "1200",
                                required: ""
                              }, "\n                          ", 512), [
                                [_vModelText, _ctx.product.fullDescription]
                              ]),
                              _createVNode("span", _hoisted_41, [
                                _hoisted_42,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                              ]),
                              _createVNode("span", _hoisted_43, [
                                _createVNode("span", {
                                  class: { 'length-limit': _ctx.product.fullDescription.length > 1199 }
                                }, _toDisplayString(_ctx.product.fullDescription.length), 3),
                                _hoisted_44
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_45, [
                            _createVNode("div", _hoisted_46, [
                              _createVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('product.long-description-index')) + ":", 1),
                              _hoisted_48
                            ]),
                            _createVNode("div", {
                              class: "col-2 pop-up-button",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.routeToEdit('fulldescriptionindex')))
                            }, [
                              _hoisted_49
                            ]),
                            _createVNode("div", _hoisted_50, [
                              _withDirectives(_createVNode("textarea", {
                                name: "textArea",
                                class: "bookit-textarea product-textarea resize-off long-description form-control",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.product.fullDescriptionIndex = $event)),
                                maxlength: "1200"
                              }, "\n                          ", 512), [
                                [_vModelText, _ctx.product.fullDescriptionIndex]
                              ]),
                              _createVNode("span", _hoisted_51, [
                                _hoisted_52,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                              ]),
                              _createVNode("span", _hoisted_53, [
                                _createVNode("span", {
                                  class: { 'length-limit': _ctx.product.fullDescriptionIndex.length > 1199 }
                                }, _toDisplayString(_ctx.product.fullDescriptionIndex.length), 3),
                                _hoisted_54
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_55, [
                        _createVNode("div", _hoisted_56, [
                          _createVNode("div", _hoisted_57, [
                            _createVNode("div", _hoisted_58, [
                              _createVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('product.region')), 1),
                              _hoisted_60,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                required: "",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.product.productRegions = $event))
                              }, null, 512), [
                                [_vShow, false],
                                [_vModelText, _ctx.product.productRegions]
                              ]),
                              _createVNode("span", _hoisted_61, [
                                _hoisted_62,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_63, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-regions',
                              params: { tagId: _ctx.foodDrinkId, productId: _ctx.id },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_64
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_65, [
                              _createVNode("div", _hoisted_66, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productRegions, (region) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "orange-marker-wrapper marker-wrapper",
                                    key: region.id
                                  }, [
                                    _createVNode("span", _hoisted_67, _toDisplayString(region.regionName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteRegion(region))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_68, [
                        _createVNode("div", _hoisted_69, [
                          _createVNode("div", _hoisted_70, [
                            _createVNode("div", _hoisted_71, [
                              _createVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('product.typeOfProduct')), 1),
                              _hoisted_73
                            ]),
                            _createVNode("div", _hoisted_74, [
                              _createVNode("div", _hoisted_75, [
                                _createVNode(_component_Multiselect, _mergeProps({
                                  class: { 'form-controll-multiselect': !_ctx.product.productTypeId },
                                  required: "",
                                  modelValue: _ctx.product.productTypeId,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.product.productTypeId = $event))
                                }, _ctx.productTypeSelect), null, 16, ["class", "modelValue"]),
                                (!_ctx.product.productTypeId)
                                  ? (_openBlock(), _createBlock("span", _hoisted_76, [
                                      _hoisted_77,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _hoisted_78
                          ]),
                          _createVNode("div", _hoisted_79, [
                            _createVNode("div", _hoisted_80, [
                              _createVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('product.subTypes')), 1)
                            ]),
                            _createVNode("div", _hoisted_82, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: { tagId: _ctx.subTypeId, productId: _ctx.id, type: 'sub-types' },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_83
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_84, [
                              _createVNode("div", _hoisted_85, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "orange-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_86, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_87, [
                        _createVNode("div", _hoisted_88, [
                          _createVNode("div", _hoisted_89, [
                            _createVNode("div", _hoisted_90, [
                              _createVNode("span", _hoisted_91, _toDisplayString(_ctx.$t('product.targetAudiences')), 1)
                            ]),
                            _createVNode("div", _hoisted_92, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: {
                                tagId: _ctx.targetAudiencesId,
                                productId: _ctx.id,
                                type: 'target-audiences',
                              },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_93
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_94, [
                              _createVNode("div", _hoisted_95, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.targetAudiencesTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "blue-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_96, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_97
                          ]),
                          _createVNode("div", _hoisted_98, [
                            _createVNode("div", _hoisted_99, [
                              _createVNode("span", _hoisted_100, _toDisplayString(_ctx.$t('product.entrance')), 1)
                            ]),
                            _createVNode("div", _hoisted_101, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: { tagId: _ctx.entranceId, productId: _ctx.id, type: 'entrance' },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_102
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_103, [
                              _createVNode("div", _hoisted_104, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entranceTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "blue-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_105, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_106
                          ]),
                          _createVNode("div", _hoisted_107, [
                            _createVNode("div", _hoisted_108, [
                              _createVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('product.foodAndDrinks')), 1)
                            ]),
                            _createVNode("div", _hoisted_110, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: { tagId: _ctx.foodDrinkId, productId: _ctx.id, type: 'food-drinks' },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_111
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_112, [
                              _createVNode("div", _hoisted_113, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodDrinkTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "blue-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_114, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_115
                          ]),
                          _createVNode("div", _hoisted_116, [
                            _createVNode("div", _hoisted_117, [
                              _createVNode("span", _hoisted_118, _toDisplayString(_ctx.$t('product.religion')), 1)
                            ]),
                            _createVNode("div", _hoisted_119, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: { tagId: _ctx.religionId, productId: _ctx.id, type: 'religion' },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_120
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_121, [
                              _createVNode("div", _hoisted_122, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.religionTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "blue-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_123, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_124
                          ]),
                          _createVNode("div", _hoisted_125, [
                            _createVNode("div", _hoisted_126, [
                              _createVNode("span", _hoisted_127, _toDisplayString(_ctx.$t('product.difficultyLevel')), 1)
                            ]),
                            _createVNode("div", _hoisted_128, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: {
                                tagId: _ctx.difficultyLevelId,
                                productId: _ctx.id,
                                type: 'Difficulty Level',
                              },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_129
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_130, [
                              _createVNode("div", _hoisted_131, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.difficultyLevelTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "orange-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_132, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_133
                          ]),
                          _createVNode("div", _hoisted_134, [
                            _createVNode("div", _hoisted_135, [
                              _createVNode("span", _hoisted_136, _toDisplayString(_ctx.$t('product.languages')), 1)
                            ]),
                            _createVNode("div", _hoisted_137, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: { tagId: _ctx.languagesId, productId: _ctx.id, type: 'languages' },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_138
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_139, [
                              _createVNode("div", _hoisted_140, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languagesTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "blue-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_141, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_142
                          ]),
                          _createVNode("div", _hoisted_143, [
                            _createVNode("div", _hoisted_144, [
                              _createVNode("span", _hoisted_145, _toDisplayString(_ctx.$t('product.transportAndParking')), 1)
                            ]),
                            _createVNode("div", _hoisted_146, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: {
                                tagId: _ctx.transportAndParkingId,
                                productId: _ctx.id,
                                type: 'transport-parking',
                              },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_147
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_148, [
                              _createVNode("div", _hoisted_149, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transportAndParkingTags(), (subtag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "blue-marker-wrapper marker-wrapper",
                                    key: subtag.id
                                  }, [
                                    _createVNode("span", _hoisted_150, _toDisplayString(subtag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteTag(subtag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_151, [
                        _createVNode("div", _hoisted_152, [
                          _createVNode("div", _hoisted_153, [
                            _createVNode("div", _hoisted_154, [
                              _createVNode("span", _hoisted_155, _toDisplayString(_ctx.$t('product.included')), 1)
                            ]),
                            _createVNode("div", _hoisted_156, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: {
                                tagId: _ctx.includedNotIncludedId,
                                productId: _ctx.id,
                                type: 'included',
                              },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_157
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_158, [
                              _createVNode("div", _hoisted_159, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productIncludedTags, (includedTag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "green-marker-wrapper marker-wrapper",
                                    key: includedTag.id
                                  }, [
                                    _createVNode("span", _hoisted_160, _toDisplayString(includedTag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteIncludedTag(includedTag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_161
                          ]),
                          _createVNode("div", _hoisted_162, [
                            _createVNode("div", _hoisted_163, [
                              _createVNode("span", _hoisted_164, _toDisplayString(_ctx.$t('product.excluded')), 1)
                            ]),
                            _createVNode("div", _hoisted_165, [
                              _createVNode(_component_router_link, {
                                to: {
                              name: 'modal-tags',
                              params: {
                                tagId: _ctx.includedNotIncludedId,
                                productId: _ctx.id,
                                type: 'excluded',
                              },
                            }
                              }, {
                                default: _withId(() => [
                                  _hoisted_166
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createVNode("div", _hoisted_167, [
                              _createVNode("div", _hoisted_168, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productExcludedTags, (excludedTag) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "red-marker-wrapper marker-wrapper",
                                    key: excludedTag.id
                                  }, [
                                    _createVNode("span", _hoisted_169, _toDisplayString(excludedTag.subTagName), 1),
                                    _createVNode("span", {
                                      class: "marker-remove",
                                      onClick: ($event: any) => (_ctx.deleteExcludedTag(excludedTag))
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_170, [
                        _createVNode("div", _hoisted_171, [
                          _createVNode("div", _hoisted_172, [
                            _createVNode("p", _hoisted_173, _toDisplayString(_ctx.$t('product.averageActivityDuration')) + ":", 1),
                            _createVNode(_component_Multiselect, _mergeProps({
                              modelValue: _ctx.product.averageDurationTime,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.product.averageDurationTime = $event))
                            }, _ctx.productAverageDuration), null, 16, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_174, [
                        _createVNode("div", _hoisted_175, [
                          (_ctx.showExtraInfoAbout)
                            ? (_openBlock(), _createBlock("div", _hoisted_176, [
                                _createVNode("div", _hoisted_177, _toDisplayString(_ctx.$t('help.aboutProductExtraField')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_178, [
                          _createVNode("div", _hoisted_179, [
                            _createVNode("div", _hoisted_180, [
                              _createVNode("p", _hoisted_181, _toDisplayString(_ctx.$t('product.extraInfo')) + ":", 1),
                              _createVNode("span", {
                                style: {"padding":"0 15px","position":"relative","top":"-3px"},
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.routeToEdit('extraInfo')))
                              }, [
                                _hoisted_182
                              ])
                            ]),
                            _withDirectives(_createVNode("textarea", {
                              name: "textArea",
                              id: "extraInfo",
                              class: "bookit-textarea product-textarea resize-off long-description form-control",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.product.extraInfo = $event)),
                              maxlength: "255",
                              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkDescription('extraInfo')))
                            }, "\n                        ", 544), [
                              [_vModelText, _ctx.product.extraInfo]
                            ]),
                            _createVNode("div", _hoisted_183, [
                              _createVNode("span", _hoisted_184, [
                                _createVNode("span", {
                                  class: { 'length-limit': _ctx.product.extraInfo.length > 254 }
                                }, _toDisplayString(_ctx.product.extraInfo.length), 3),
                                _hoisted_185
                              ])
                            ]),
                            _createVNode("i", {
                              class: "icon-f icon-info fs-20 info-icon",
                              onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showExtraInfoAbout = false)),
                              onMouseenter: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showExtraInfoAbout = true))
                            }, null, 32)
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_186, [
                        _createVNode("div", _hoisted_187, [
                          _createVNode("div", _hoisted_188, [
                            _createVNode("span", _hoisted_189, _toDisplayString(_ctx.$t('product.receiveNotifications')), 1),
                            _createVNode("span", null, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                class: "toggle",
                                checked: _ctx.product.receiveNotifications,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.product.receiveNotifications = $event))
                              }, null, 8, ["checked"]), [
                                [_vModelCheckbox, _ctx.product.receiveNotifications]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_190, [
                  _createVNode("div", _hoisted_191, [
                    _createVNode("h5", _hoisted_192, [
                      _createVNode("button", _hoisted_193, _toDisplayString(_ctx.$t('product.productAddress')), 1),
                      _hoisted_194
                    ])
                  ]),
                  _createVNode("div", _hoisted_195, [
                    _createVNode("div", _hoisted_196, [
                      _createVNode("div", _hoisted_197, [
                        _createVNode("div", _hoisted_198, [
                          _createVNode("div", _hoisted_199, [
                            _createVNode("div", _hoisted_200, [
                              _createVNode("span", _hoisted_201, _toDisplayString(_ctx.$t('product.productAddress')), 1),
                              _hoisted_202
                            ])
                          ]),
                          _createVNode("div", _hoisted_203, [
                            _withDirectives(_createVNode("input", {
                              placeholder: _ctx.$t('address.placeholder.address'),
                              required: "",
                              class: "bookit-input product-input form-control h48",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.product.address = $event)),
                              maxlength: "100",
                              onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.checkDescription('address')))
                            }, null, 40, ["placeholder"]), [
                              [_vModelText, _ctx.product.address]
                            ]),
                            _hoisted_204
                          ]),
                          _createVNode("div", {
                            class: ["col-12", _ctx.product.longitude !== 0 && _ctx.product.latitude !== 0 ? 'col-lg-6' : ''],
                            style: {"margin-bottom":"20px"}
                          }, [
                            _createVNode("button", {
                              class: "btn select-location browse-photo browse-button green-button",
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.routeToSelectLocation && _ctx.routeToSelectLocation(...args))),
                              style: {"margin":"0 auto"},
                              type: "button"
                            }, [
                              _hoisted_205,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('link.chooseLocationOnMap')), 1)
                            ])
                          ], 2),
                          (_ctx.product.longitude !== 0 && _ctx.product.latitude !== 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_206, [
                                _createVNode("div", _hoisted_207, null, 512)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_208, [
                            _createVNode("div", _hoisted_209, [
                              _createVNode("div", _hoisted_210, [
                                _createVNode("span", _hoisted_211, _toDisplayString(_ctx.$t('product.city')), 1),
                                _hoisted_212
                              ]),
                              _createVNode("div", _hoisted_213, [
                                _createVNode("div", _hoisted_214, [
                                  _createVNode(_component_Multiselect, _mergeProps({
                                    class: { 'form-controll-multiselect': !_ctx.product.cityId },
                                    required: "",
                                    canDeselect: false,
                                    modelValue: _ctx.product.cityId,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.product.cityId = $event))
                                  }, _ctx.citySelect), null, 16, ["class", "modelValue"]),
                                  (_ctx.product.cityId)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 0,
                                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.product.cityId = null)),
                                        class: "marker-remove"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _withDirectives(_createVNode("input", {
                                  required: "",
                                  class: "d-none",
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.product.cityId = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.product.cityId]
                                ]),
                                _createVNode("span", _hoisted_215, [
                                  _hoisted_216,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                                ]),
                                _hoisted_217
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_218, [
                            _createVNode("div", _hoisted_219, [
                              _createVNode("div", _hoisted_220, [
                                _createVNode("span", _hoisted_221, _toDisplayString(_ctx.$t('address.region')), 1),
                                _hoisted_222
                              ]),
                              _createVNode("div", _hoisted_223, [
                                _createVNode("div", _hoisted_224, [
                                  _createVNode(_component_Multiselect, _mergeProps({
                                    class: { 'form-controll-multiselect': !_ctx.product.regionId },
                                    required: "",
                                    canDeselect: false,
                                    modelValue: _ctx.product.regionId,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.product.regionId = $event))
                                  }, _ctx.addressRegionSelect), null, 16, ["class", "modelValue"]),
                                  (_ctx.product.regionId)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 0,
                                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.product.regionId = null)),
                                        class: "marker-remove"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _withDirectives(_createVNode("input", {
                                  required: "",
                                  class: "d-none",
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.product.regionId = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.product.regionId]
                                ]),
                                _createVNode("span", _hoisted_225, [
                                  _hoisted_226,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                                ]),
                                _hoisted_227
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_228, [
                            _createVNode("div", _hoisted_229, [
                              _createVNode("span", _hoisted_230, _toDisplayString(_ctx.$t('address.arrival.instructions')), 1)
                            ]),
                            _createVNode("div", {
                              class: "col-2 pop-up-button",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.routeToEdit('arrivalInstructions')))
                            }, [
                              _hoisted_231
                            ]),
                            _createVNode("div", _hoisted_232, [
                              _withDirectives(_createVNode("textarea", {
                                name: "textArea",
                                id: "arrivalInstructions",
                                class: "bookit-textarea product-textarea resize-off long-description form-control",
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.product.arrivalInstructions = $event)),
                                maxlength: "300",
                                onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.checkDescription('arrival')))
                              }, "\n                          ", 544), [
                                [_vModelText, _ctx.product.arrivalInstructions]
                              ]),
                              _createVNode("span", _hoisted_233, [
                                _createVNode("span", {
                                  class: {
                                'length-limit':
                                  (_ctx.product.arrivalInstructions ? _ctx.product.arrivalInstructions.length : 0) > 299,
                              }
                                }, _toDisplayString(_ctx.product.arrivalInstructions ? _ctx.product.arrivalInstructions.length : 0), 3),
                                _hoisted_234
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_235, [
                            _createVNode("div", _hoisted_236, [
                              _createVNode("span", _hoisted_237, _toDisplayString(_ctx.$t('address.parking.instructions')), 1)
                            ]),
                            _createVNode("div", {
                              class: "col-2 pop-up-button",
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.routeToEdit('parkingInstructions')))
                            }, [
                              _hoisted_238
                            ]),
                            _createVNode("div", _hoisted_239, [
                              _withDirectives(_createVNode("textarea", {
                                name: "textArea",
                                id: "parkingInstructions",
                                class: "bookit-textarea product-textarea resize-off long-description form-control",
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.product.parkingInstructions = $event)),
                                maxlength: "300",
                                onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.checkDescription('parking')))
                              }, "\n                          ", 544), [
                                [_vModelText, _ctx.product.parkingInstructions]
                              ]),
                              _createVNode("span", _hoisted_240, [
                                _createVNode("span", {
                                  class: {
                                'length-limit':
                                  (_ctx.product.parkingInstructions ? _ctx.product.parkingInstructions.length : 0) > 299,
                              }
                                }, _toDisplayString(_ctx.product.parkingInstructions ? _ctx.product.parkingInstructions.length : 0), 3),
                                _hoisted_241
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_242, [
                  _createVNode("div", _hoisted_243, [
                    _createVNode("h5", _hoisted_244, [
                      _createVNode("button", _hoisted_245, _toDisplayString(_ctx.$t('product.moreInfo')), 1),
                      _hoisted_246
                    ])
                  ]),
                  _createVNode("div", _hoisted_247, [
                    _createVNode("div", _hoisted_248, [
                      _createVNode("div", _hoisted_249, [
                        _createVNode(_component_ProductMoreInfo, {
                          onAddCustomInfoType: _ctx.addCustomInfoType,
                          onRemoveCustomInfoType: _ctx.removeCustomInfoType,
                          editMode: true,
                          items: _ctx.product.productInfos,
                          productId: _ctx.product.id
                        }, null, 8, ["onAddCustomInfoType", "onRemoveCustomInfoType", "items", "productId"])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_250, [
                  _createVNode("div", _hoisted_251, [
                    _createVNode("h5", _hoisted_252, [
                      _createVNode("button", _hoisted_253, _toDisplayString(_ctx.$t('product.productTime&Duration')), 1),
                      _hoisted_254
                    ])
                  ]),
                  _createVNode("div", _hoisted_255, [
                    _createVNode("div", _hoisted_256, [
                      _createVNode(_Transition, { name: "help" }, {
                        default: _withId(() => [
                          (_ctx.showproductActivityTimeDurationInfo)
                            ? (_openBlock(), _createBlock("div", _hoisted_257, [
                                _createVNode("small", _hoisted_258, _toDisplayString(_ctx.$t('help.aboutProductTime&Duration')), 1),
                                _createVNode("i", {
                                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showproductActivityTimeDurationInfo = !_ctx.showproductActivityTimeDurationInfo)),
                                  class: "icon-f icon-arrow-back fs-28"
                                })
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_259, [
                                _createVNode("div", _hoisted_260, [
                                  _createVNode("a", {
                                    href: _ctx.product.pmsLink,
                                    class: "btn browse-photo browse-button green-button mr-3",
                                    target: "_blank"
                                  }, [
                                    _hoisted_261,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('product.openCalendarInPms')), 1)
                                  ], 8, ["href"]),
                                  _createVNode("button", {
                                    type: "button",
                                    class: _ctx.showFilter ? 'filter-btn-pressed' : 'filter-btn',
                                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showFilter = !_ctx.showFilter))
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
                                    _hoisted_262
                                  ], 2),
                                  _createVNode("i", {
                                    class: "icon-f icon-info fs-20 info-icon",
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showproductActivityTimeDurationInfo = !_ctx.showproductActivityTimeDurationInfo))
                                  })
                                ]),
                                _createVNode("div", _hoisted_263, [
                                  _createVNode(_component_ProductSlotsTable, {
                                    slots: _ctx.product.productSlots,
                                    "edit-mode": false,
                                    showFilter: _ctx.showFilter,
                                    class: "mx-2"
                                  }, null, 8, ["slots", "showFilter"])
                                ])
                              ]))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_264, [
                  _createVNode("div", _hoisted_265, [
                    _createVNode("h5", _hoisted_266, [
                      _createVNode("button", _hoisted_267, _toDisplayString(_ctx.$t('product.photos&Video')), 1),
                      _hoisted_268
                    ])
                  ]),
                  _createVNode("div", _hoisted_269, [
                    _createVNode("div", _hoisted_270, [
                      _createVNode(_Transition, { name: "help" }, {
                        default: _withId(() => [
                          (_ctx.showProductPhotosVideoInfo)
                            ? (_openBlock(), _createBlock("div", _hoisted_271, [
                                _createVNode("div", _hoisted_272, [
                                  _createVNode("a", _hoisted_273, _toDisplayString(_ctx.$t('help.watchTheVideo')), 1)
                                ]),
                                _createVNode("small", _hoisted_274, _toDisplayString(_ctx.$t('help.aboutProductPhotosVideo')), 1),
                                _createVNode("i", {
                                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.showProductPhotosVideoInfo = !_ctx.showProductPhotosVideoInfo)),
                                  class: "icon-f icon-arrow-back fs-28"
                                })
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_275, [
                                _createVNode("i", {
                                  class: "icon-f icon-info fs-20 info-icon",
                                  style: {"z-index":"2"},
                                  onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.showProductPhotosVideoInfo = !_ctx.showProductPhotosVideoInfo))
                                }),
                                _createVNode("div", _hoisted_276, [
                                  _createVNode("div", _hoisted_277, [
                                    _createVNode("div", _hoisted_278, [
                                      _createVNode("button", {
                                        class: ["btn browse-photo browse-button green-button", 
                                _ctx.product && _ctx.product.productImages && _ctx.product.productImages.length >= 20
                                  ? 'images-limit-reached'
                                  : ''
                              ],
                                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.startUploadImage($event, 'image-upload-input'))),
                                        style: {"margin":"0 auto"},
                                        type: "button"
                                      }, [
                                        _createVNode("input", {
                                          type: "file",
                                          name: "",
                                          id: "image-upload-input",
                                          style: {"display":"none"},
                                          onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.uploadingImageValidation($event, false))),
                                          accept: "image/*"
                                        }, null, 32),
                                        _hoisted_279,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('product.browsePhoto')), 1)
                                      ], 2)
                                    ]),
                                    _createVNode("p", _hoisted_280, _toDisplayString(_ctx.$t('product.supportedFiles')), 1),
                                    _createVNode("p", {
                                      class: ["upload-article", 
                              _ctx.product.productImages && _ctx.product.productImages.length === 0 ? 'last-upload-article' : ''
                            ]
                                    }, _toDisplayString(_ctx.$t('product-page-edit.photos-videos.5mb-size')), 3),
                                    (_ctx.product.productImages && _ctx.product.productImages.length > 0)
                                      ? (_openBlock(), _createBlock("p", {
                                          key: 0,
                                          class: ["upload-article", 
                              _ctx.product.productImages && _ctx.product.productImages.length > 0 ? 'last-upload-article' : ''
                            ]
                                        }, _toDisplayString(_ctx.$t('product-page-edit.photos-videos.dragPhoto')), 3))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_281, [
                                      _createVNode("div", _hoisted_282, [
                                        (_ctx.imgSrc)
                                          ? (_openBlock(), _createBlock("div", _hoisted_283, [
                                              _createVNode(_component_cropper, {
                                                ref: "cropperLib",
                                                class: "cropper",
                                                src: _ctx.imgSrc,
                                                "stencil-props": {
                                    aspectRatio: 10 / 12,
                                  }
                                              }, null, 8, ["src"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.imgSrc)
                                          ? (_openBlock(), _createBlock("div", _hoisted_284, [
                                              _createVNode("div", _hoisted_285, [
                                                _createVNode("div", _hoisted_286, [
                                                  _createVNode("div", _hoisted_287, [
                                                    _createVNode("button", {
                                                      type: "button",
                                                      class: "btn save-image-btn browse-photo green-button mt-4",
                                                      onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.saveImage && _ctx.saveImage(...args)))
                                                    }, _toDisplayString(_ctx.$t('button.save')), 1)
                                                  ]),
                                                  _createVNode("div", _hoisted_288, [
                                                    _createVNode("button", {
                                                      type: "button",
                                                      class: "clear-image-btn btn browse-photo gray-button mt-4",
                                                      onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                                                    }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (_ctx.product.productImages)
                                      ? (_openBlock(), _createBlock("div", _hoisted_289, [
                                          _createVNode(_component_draggable, {
                                            modelValue: _ctx.product.productImages,
                                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.product.productImages = $event)),
                                            group: "images",
                                            onStart: _cache[43] || (_cache[43] = ($event: any) => (_ctx.drag = true)),
                                            onEnd: _cache[44] || (_cache[44] = ($event: any) => (_ctx.drag = false)),
                                            "item-key": "id",
                                            class: "row",
                                            style: {"margin":"0"}
                                          }, _createSlots({
                                            item: _withId(({ element, index }) => [
                                              _createVNode("div", _hoisted_290, [
                                                (element.id)
                                                  ? (_openBlock(), _createBlock("div", _hoisted_291, [
                                                      (element && !element.isConfirmed)
                                                        ? (_openBlock(), _createBlock("div", _hoisted_292, [
                                                            _createVNode("div", {
                                                              class: "mandatory-warning-info dp-none",
                                                              id: 'product-image-' + index
                                                            }, [
                                                              _createVNode("div", _hoisted_293, _toDisplayString(_ctx.$t('product.image.notConfirmed')), 1)
                                                            ], 8, ["id"]),
                                                            _createVNode("div", _hoisted_294, [
                                                              _createVNode("i", {
                                                                class: "icon-f icon-not-confirmed fs-20",
                                                                onMouseleave: ($event: any) => (_ctx.hideWarning(index)),
                                                                onMouseenter: ($event: any) => (_ctx.showWarning(index))
                                                              }, null, 40, ["onMouseleave", "onMouseenter"])
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (element.isMainImage)
                                                        ? (_openBlock(), _createBlock("span", _hoisted_295))
                                                        : _createCommentVNode("", true),
                                                      _createVNode("img", {
                                                        src: element.pathSmall,
                                                        alt: element.name,
                                                        onClick: ($event: any) => (_ctx.showImageSettings(index))
                                                      }, null, 8, ["src", "alt", "onClick"]),
                                                      _createVNode("ul", {
                                                        class: "dropdown-menu",
                                                        id: index + '-image-dropdown-settings'
                                                      }, [
                                                        _createVNode("li", {
                                                          onClick: ($event: any) => (_ctx.routeToEditFile(element.id, 'image'))
                                                        }, _toDisplayString(_ctx.$t('button.edit')), 9, ["onClick"]),
                                                        (!element.isMainImage)
                                                          ? (_openBlock(), _createBlock("li", {
                                                              key: 0,
                                                              onClick: ($event: any) => (_ctx.makeImageAsMain(element.id))
                                                            }, [
                                                              _createVNode("a", _hoisted_296, _toDisplayString(_ctx.$t('button.setAsCover')), 1)
                                                            ], 8, ["onClick"]))
                                                          : _createCommentVNode("", true),
                                                        _createVNode("li", {
                                                          onClick: ($event: any) => (_ctx.removeImageFromProduct(element.id))
                                                        }, [
                                                          _createVNode("a", _hoisted_297, _toDisplayString(_ctx.$t('button.delete')), 1)
                                                        ], 8, ["onClick"])
                                                      ], 8, ["id"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 2
                                          }, [
                                            (_ctx.product.productImages > 6)
                                              ? {
                                                  name: "footer",
                                                  fn: _withId(() => [
                                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(6 - _ctx.product.productImages.length, (index) => {
                                                      return (_openBlock(), _createBlock("div", {
                                                        class: "col-4 col-md-2 photo-container pointer",
                                                        key: index
                                                      }, [
                                                        _hoisted_298
                                                      ]))
                                                    }), 128))
                                                  ])
                                                }
                                              : undefined
                                          ]), 1032, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createVNode("div", _hoisted_299, [
                                    _createVNode("div", _hoisted_300, [
                                      _createVNode("p", null, _toDisplayString(_ctx.$t('product.clickOnThePhoto')), 1),
                                      _createVNode("p", null, _toDisplayString(_ctx.$t('product-page-edit.photos-videos.allow20')), 1)
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_301, [
                                  _createVNode("div", _hoisted_302, [
                                    (!_ctx.product.ticketImagePath || !_ctx.product.ticketImagePathSmall)
                                      ? (_openBlock(), _createBlock("div", _hoisted_303, [
                                          _createVNode("div", _hoisted_304, [
                                            _createVNode("div", _hoisted_305, [
                                              _createVNode("p", _hoisted_306, _toDisplayString(_ctx.$t('ticket.productPage.title')), 1)
                                            ]),
                                            _createVNode("div", _hoisted_307, [
                                              _createVNode("span", {
                                                style: {"top":"0!important"},
                                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.startUploadImage($event, 'ticket-image-upload-input'))),
                                                class: "icon dark-squared-plus"
                                              }, [
                                                _createVNode("input", {
                                                  type: "file",
                                                  name: "",
                                                  id: "ticket-image-upload-input",
                                                  style: {"display":"none"},
                                                  onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.uploadingTicketImageValidation($event))),
                                                  accept: "image/*"
                                                }, null, 32)
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_308, [
                                      _createVNode("div", _hoisted_309, [
                                        (_ctx.ticketImgSrc)
                                          ? (_openBlock(), _createBlock("div", _hoisted_310, [
                                              _createVNode(_component_cropper, {
                                                ref: "cropperLib",
                                                class: "cropper",
                                                src: _ctx.ticketImgSrc,
                                                "stencil-props": {
                                                  aspectRatio: 157 / 63
                                              }
                                              }, null, 8, ["src"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.ticketImgSrc)
                                          ? (_openBlock(), _createBlock("div", _hoisted_311, [
                                              _createVNode("div", _hoisted_312, [
                                                _createVNode("div", _hoisted_313, [
                                                  _createVNode("div", _hoisted_314, [
                                                    _createVNode("button", {
                                                      type: "button",
                                                      class: "btn save-image-btn browse-photo green-button mt-4",
                                                      onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.saveTicketImage && _ctx.saveTicketImage(...args)))
                                                    }, _toDisplayString(_ctx.$t('button.save')), 1)
                                                  ]),
                                                  _createVNode("div", _hoisted_315, [
                                                    _createVNode("button", {
                                                      type: "button",
                                                      class: "clear-image-btn btn browse-photo gray-button mt-4",
                                                      onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.clearTicketImage && _ctx.clearTicketImage(...args)))
                                                    }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (_ctx.product.ticketImagePath || _ctx.product.ticketImagePathSmall)
                                      ? (_openBlock(), _createBlock("div", _hoisted_316, [
                                          _createVNode("div", _hoisted_317, [
                                            _createVNode("div", _hoisted_318, [
                                              _createVNode("div", _hoisted_319, [
                                                _createVNode("div", _hoisted_320, [
                                                  _createVNode("img", {
                                                    src: _ctx.product.ticketImagePath
                                                  }, null, 8, ["src"])
                                                ])
                                              ]),
                                              _createVNode("div", _hoisted_321, [
                                                _createVNode("div", _hoisted_322, [
                                                  _createVNode("img", {
                                                    src: _ctx.product.ticketImagePathSmall
                                                  }, null, 8, ["src"])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_323, [
                                            _createVNode("span", {
                                              style: {"top":"0!important"},
                                              onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.startUploadImage($event, 'ticket-image-upload-input'))),
                                              class: "dark-squared"
                                            }, [
                                              _hoisted_324,
                                              _createVNode("input", {
                                                type: "file",
                                                name: "",
                                                id: "ticket-image-upload-input",
                                                style: {"display":"none"},
                                                onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.uploadingTicketImageValidation($event))),
                                                accept: "image/*"
                                              }, null, 32)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createVNode("div", _hoisted_325, [
                                  _createVNode("div", _hoisted_326, [
                                    _createVNode("div", _hoisted_327, [
                                      _createVNode("div", _hoisted_328, [
                                        _createVNode("button", {
                                          class: "btn browse-photo green-button",
                                          type: "button",
                                          onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.addYoutubeInput && _ctx.addYoutubeInput(...args)))
                                        }, [
                                          _hoisted_329,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('product.addMovie')), 1)
                                        ])
                                      ]),
                                      _createVNode("div", _hoisted_330, [
                                        _createVNode("span", _hoisted_331, _toDisplayString(_ctx.$t('product.addVideo')), 1)
                                      ]),
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productVideos, (videoLink, i) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "video-link col-12",
                                          key: videoLink.id
                                        }, [
                                          _createVNode("div", _hoisted_332, [
                                            _createVNode("div", _hoisted_333, [
                                              _withDirectives(_createVNode("input", {
                                                id: `${videoLink.id}-${i}`,
                                                type: "text",
                                                class: "bookit-input product-input",
                                                "onUpdate:modelValue": ($event: any) => (videoLink.path = $event)
                                              }, null, 8, ["id", "onUpdate:modelValue"]), [
                                                [_vModelText, videoLink.path]
                                              ])
                                            ]),
                                            _createVNode("div", _hoisted_334, [
                                              _createVNode("span", {
                                                class: "icon pointer",
                                                onClick: ($event: any) => (_ctx.removeYouTubeLink(i))
                                              }, [
                                                _hoisted_335
                                              ], 8, ["onClick"])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_336, [
                  _createVNode("div", _hoisted_337, [
                    _createVNode("h5", _hoisted_338, [
                      _createVNode("button", _hoisted_339, _toDisplayString(_ctx.$t('product.documents')), 1),
                      _hoisted_340
                    ])
                  ]),
                  _createVNode("div", _hoisted_341, [
                    _createVNode("div", _hoisted_342, [
                      _createVNode(_Transition, { name: "help" }, {
                        default: _withId(() => [
                          (_ctx.showDocumentsHelp)
                            ? (_openBlock(), _createBlock("div", _hoisted_343, [
                                _createVNode("small", _hoisted_344, _toDisplayString(_ctx.$t('help.aboutProductPhotosVideo')), 1),
                                _createVNode("i", {
                                  onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.showDocumentsHelp = !_ctx.showDocumentsHelp)),
                                  class: "icon-f icon-arrow-back fs-28"
                                })
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_345, [
                                _createVNode("i", {
                                  class: "icon-f icon-info fs-20 info-icon",
                                  style: {"z-index":"2"},
                                  onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.showDocumentsHelp = !_ctx.showDocumentsHelp))
                                }),
                                _createVNode("div", _hoisted_346, [
                                  _createVNode("div", _hoisted_347, [
                                    _createVNode("div", _hoisted_348, [
                                      _createVNode("button", {
                                        class: "btn browse-photo green-button",
                                        type: "button",
                                        onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.callUploadingFunction && _ctx.callUploadingFunction(...args)))
                                      }, [
                                        _createVNode("input", {
                                          type: "file",
                                          name: "file-upload-input",
                                          id: "file-upload-input",
                                          style: {"display":"none"},
                                          onChange: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.uploadingFileValidation && _ctx.uploadingFileValidation(...args)))
                                        }, null, 32),
                                        _hoisted_349,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('product.browseFile')), 1)
                                      ]),
                                      _createVNode("p", null, _toDisplayString(_ctx.$t('product.forExampleInsurance')), 1),
                                      _createVNode("p", null, _toDisplayString(_ctx.$t('product.about-documents-formats')), 1)
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_350, [
                                  _createVNode("div", _hoisted_351, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productDocuments, (document, index) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "col-4 document-container",
                                        key: document.id
                                      }, [
                                        _createVNode("div", {
                                          class: "document-wrapper",
                                          onClick: ($event: any) => (_ctx.showDocumentSettings(index))
                                        }, [
                                          _createVNode("a", {
                                            target: "_blank",
                                            href: document.path,
                                            class: "file-link"
                                          }, _toDisplayString(document.name), 9, ["href"]),
                                          _createVNode("i", {
                                            class: [_ctx.getDocIcon(document.name), "icon-f fs-24"]
                                          }, null, 2),
                                          _createVNode("ul", {
                                            class: "dropdown-menu",
                                            id: index + '-document-dropdown-settings'
                                          }, [
                                            _createVNode("li", {
                                              onClick: ($event: any) => (_ctx.routeToEditFile(document.id, 'document'))
                                            }, _toDisplayString(_ctx.$t('button.edit')), 9, ["onClick"]),
                                            _createVNode("li", {
                                              onClick: ($event: any) => (_ctx.deleteDocument(document))
                                            }, [
                                              _createVNode("span", _hoisted_352, _toDisplayString(_ctx.$t('button.delete')), 1)
                                            ], 8, ["onClick"])
                                          ], 8, ["id"])
                                        ], 8, ["onClick"])
                                      ]))
                                    }), 128)),
                                    (_ctx.product.productDocuments && _ctx.product.productDocuments.length < 6)
                                      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(6 - _ctx.product.productDocuments.length, (index) => {
                                          return (_openBlock(), _createBlock("div", {
                                            class: "col-4 document-container",
                                            key: index
                                          }, [
                                            _hoisted_353
                                          ]))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_354, [
                  _createVNode("div", _hoisted_355, [
                    _createVNode("h5", _hoisted_356, [
                      _createVNode("button", _hoisted_357, _toDisplayString(_ctx.$t('product.pricing')), 1),
                      _hoisted_358
                    ])
                  ]),
                  _createVNode("div", _hoisted_359, [
                    _createVNode("div", _hoisted_360, [
                      _createVNode("div", {
                        class: ["additional-section col-12", _ctx.product.productPrices.length > 0 ? 'margin-bottom12' : '']
                      }, [
                        _createVNode("div", _hoisted_361, [
                          _createVNode("div", _hoisted_362, [
                            _createVNode("button", {
                              class: "btn browse-photo browse-button green-button",
                              type: "button",
                              onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.createNewPricing && _ctx.createNewPricing(...args)))
                            }, [
                              _hoisted_363,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('product.newPriceList')), 1)
                            ])
                          ])
                        ])
                      ], 2),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productPrices, (pricing, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "several-section-wrapper",
                          key: pricing.id
                        }, [
                          (index < 3 || _ctx.showAllPrices)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: "several-section pricing-section",
                                style: `opacity: ${pricing.deletedAt !== null ? '0.6' : ''}`
                              }, [
                                _createVNode("div", _hoisted_364, [
                                  _createVNode("div", _hoisted_365, [
                                    _createVNode("p", _hoisted_366, _toDisplayString(_ctx.$t('keyword.name')), 1),
                                    _createVNode("p", _hoisted_367, _toDisplayString(pricing.title), 1)
                                  ]),
                                  _createVNode("div", _hoisted_368, [
                                    _createVNode("p", _hoisted_369, _toDisplayString(_ctx.$t('priceList.date')), 1),
                                    _createVNode("p", _hoisted_370, _toDisplayString(_ctx.formatDate(pricing.fromDate)), 1),
                                    _createVNode("p", _hoisted_371, _toDisplayString(_ctx.formatDate(pricing.toDate)), 1)
                                  ]),
                                  _createVNode("div", _hoisted_372, [
                                    _createVNode("p", _hoisted_373, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                                    _createVNode("p", _hoisted_374, _toDisplayString(_ctx.findCurrencySymbol(pricing.id)), 1)
                                  ]),
                                  _createVNode("div", _hoisted_375, [
                                    _createVNode("p", _hoisted_376, _toDisplayString(_ctx.$t('product.price-type')), 1),
                                    _createVNode("p", _hoisted_377, _toDisplayString(_ctx.findPriceTypeName(pricing.id)), 1)
                                  ]),
                                  _createVNode("div", _hoisted_378, [
                                    _createVNode("i", {
                                      class: "icon-f icon-pencil-edit fs-16",
                                      onClick: ($event: any) => (_ctx.routeToPriceListactions(_ctx.id, pricing.id))
                                    }, null, 8, ["onClick"])
                                  ])
                                ])
                              ], 4))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      (_ctx.product.productPrices.length > 3)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.showAllPrices = !_ctx.showAllPrices)),
                            class: "pointer text-center several-section m-0",
                            style: {"color":"#00bfdb","text-decoration":"underline"}
                          }, _toDisplayString(_ctx.showAllPrices ? _ctx.$t('btn.show-less') : _ctx.$t('btn.show-more')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_379, [
                  _createVNode("div", _hoisted_380, [
                    _createVNode("h5", _hoisted_381, [
                      _createVNode("button", _hoisted_382, _toDisplayString(_ctx.$t('product.faq')), 1),
                      _hoisted_383
                    ])
                  ]),
                  _createVNode("div", _hoisted_384, [
                    _createVNode("div", _hoisted_385, [
                      _createVNode("div", _hoisted_386, [
                        _createVNode("p", _hoisted_387, _toDisplayString(_ctx.$t('product.faqInfo2')), 1),
                        _createVNode("div", _hoisted_388, [
                          (_ctx.product.productFaqs && _ctx.product.productFaqs.length < 20)
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.addFAQ())),
                                type: "button",
                                class: "btn browse-photo browse-button green-button mb5"
                              }, [
                                _hoisted_389,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('product.addNewQuestion')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_ProductFAQs, {
                          onDeleteFAQItem: _ctx.deleteFAQItem,
                          editMode: true,
                          items: _ctx.product.productFaqs,
                          productId: _ctx.id
                        }, null, 8, ["onDeleteFAQItem", "items", "productId"])
                      ])
                    ])
                  ])
                ]),
                (_ctx.product.id)
                  ? (_openBlock(), _createBlock("div", _hoisted_390, [
                      _createVNode("div", _hoisted_391, [
                        _createVNode("h5", _hoisted_392, [
                          _createVNode("button", _hoisted_393, _toDisplayString(_ctx.$t('providers.notifications.title')), 1),
                          _hoisted_394
                        ])
                      ]),
                      _createVNode("div", _hoisted_395, [
                        _createVNode("div", _hoisted_396, [
                          _createVNode("div", _hoisted_397, [
                            _createVNode(_component_NotificationsRestrictions, {
                              productId: _ctx.product.id,
                              restrictions: _ctx.product.productsNotificationsRestrictions,
                              editMode: true
                            }, null, 8, ["productId", "restrictions"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_398, [
                  _createVNode("div", _hoisted_399, [
                    _createVNode("h5", _hoisted_400, [
                      _createVNode("button", _hoisted_401, _toDisplayString(_ctx.$t('product.general')), 1),
                      _hoisted_402
                    ])
                  ]),
                  _createVNode("div", _hoisted_403, [
                    _createVNode("div", _hoisted_404, [
                      _createVNode("div", _hoisted_405, [
                        _createVNode("div", _hoisted_406, [
                          _createVNode("p", _hoisted_407, _toDisplayString(_ctx.$t('catalog.productId')) + ":", 1),
                          _createVNode("p", _hoisted_408, _toDisplayString(_ctx.id), 1)
                        ]),
                        _createVNode("div", _hoisted_409, [
                          _createVNode("p", _hoisted_410, _toDisplayString(_ctx.$t('product.createdDate')) + ":", 1),
                          _createVNode("p", _hoisted_411, _toDisplayString(_ctx.momentFormat(_ctx.product.createdAt, 'datetime')), 1)
                        ]),
                        _createVNode("div", _hoisted_412, [
                          _createVNode("p", _hoisted_413, _toDisplayString(_ctx.$t('catalog.provider')) + ":", 1),
                          _createVNode(_component_router_link, {
                            to: { name: 'provider-view', params: { id: _ctx.product.providerId } }
                          }, {
                            default: _withId(() => [
                              _createVNode("p", _hoisted_414, _toDisplayString(_ctx.product.providerName), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _createVNode("div", _hoisted_415, [
                          _createVNode("p", _hoisted_416, _toDisplayString(_ctx.$t('product.operationStatus.title')) + ":", 1),
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: _ctx.product.operationStatus,
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.product.operationStatus = $event))
                          }, _ctx.productOperationStatus), null, 16, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_417, [
                          _createVNode("button", {
                            class: "delete-button",
                            onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.deleteProduct && _ctx.deleteProduct(...args))),
                            type: "button"
                          }, _toDisplayString(_ctx.$t('button.deleteProduct')), 1)
                        ]),
                        _createVNode("div", _hoisted_418, [
                          _createVNode("p", _hoisted_419, _toDisplayString(_ctx.$t('catalog.calendarColor')) + ":", 1),
                          _withDirectives(_createVNode("input", {
                            type: "color",
                            id: "color-picker-input",
                            class: "bookit-color-picker",
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.product.calendarColor = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.product.calendarColor]
                          ])
                        ]),
                        _createVNode("div", _hoisted_420, [
                          _createVNode("p", _hoisted_421, _toDisplayString(_ctx.$t('product.specialId')) + ":", 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            maxlength: "255",
                            class: "bookit-input product-input form-control h48",
                            "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.product.specialId = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.product.specialId]
                          ]),
                          _createVNode("span", _hoisted_422, [
                            _createVNode("span", {
                              class: { 'length-limit': _ctx.product.specialId?.length > 254 }
                            }, _toDisplayString(_ctx.product.specialId ? _ctx.product.specialId.length : 0), 3),
                            _hoisted_423
                          ])
                        ]),
                        _createVNode("div", _hoisted_424, [
                          _createVNode("div", _hoisted_425, [
                            _createVNode("span", _hoisted_426, _toDisplayString(_ctx.$t('catalog.order-limitation')), 1),
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.product.orderLimitation = $event)),
                              type: "text",
                              onKeypress: _cache[64] || (_cache[64] = ($event: any) => (_ctx.isNumber($event))),
                              onFocus: _cache[65] || (_cache[65] = ($event: any) => (
                                    _ctx.product.orderLimitation =
                                        _ctx.product.orderLimitation == 0 ? '' : _ctx.product.orderLimitation
                                )),
                              onBlur: _cache[66] || (_cache[66] = ($event: any) => (
                                    _ctx.product.orderLimitation =
                                        _ctx.product.orderLimitation == '' ? 0 : _ctx.product.orderLimitation
                                )),
                              style: {"width":"inherit","max-width":"130px"},
                              class: "bookit-input"
                            }, null, 544), [
                              [_vModelText, _ctx.product.orderLimitation]
                            ]),
                            _createVNode("span", _hoisted_427, _toDisplayString(_ctx.$t('label.tickets')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_428, [
                          _createVNode("p", _hoisted_429, _toDisplayString(_ctx.$t('productPage.general.policyLabel')) + ":", 1),
                          _createVNode("span", {
                            class: "pop-up-button",
                            onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.routeToEdit('policy')))
                          }, [
                            _hoisted_430
                          ])
                        ]),
                        _createVNode("div", _hoisted_431, [
                          _withDirectives(_createVNode("textarea", {
                            name: "textArea",
                            class: "bookit-textarea product-textarea resize-off long-description form-control",
                            "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => (_ctx.product.policy = $event)),
                            maxlength: "255"
                          }, "\n                      ", 512), [
                            [_vModelText, _ctx.product.policy]
                          ]),
                          _createVNode("span", _hoisted_432, [
                            _createVNode("span", {
                              class: {
                            'length-limit': _ctx.product.policy?.length > 254,
                          }
                            }, _toDisplayString(_ctx.product.policy?.length || 0), 3),
                            _hoisted_433
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.priceTypes, (priceType) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "col-12 change-registration-type",
                            key: priceType.id
                          }, [
                            _createVNode("div", _hoisted_434, [
                              _createVNode("span", null, [
                                _withDirectives(_createVNode("input", {
                                  type: "checkbox",
                                  class: "toggle",
                                  value: priceType.id,
                                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (_ctx.product.availableProductPriceTypes = $event)),
                                  onClick: _withModifiers(($event: any) => (_ctx.disactivateOrActivateProductPriceType($event, priceType.id)), ["stop"])
                                }, null, 8, ["value", "onClick"]), [
                                  [_vModelCheckbox, _ctx.product.availableProductPriceTypes]
                                ])
                              ]),
                              _createVNode("span", _hoisted_435, _toDisplayString(_ctx.$t(`product.canCreateSlotDuringCreatingOrder.${priceType.originName.replace(' ', '').toLocaleLowerCase()}`)), 1)
                            ])
                          ]))
                        }), 128)),
                        _createVNode("div", _hoisted_436, [
                          _createVNode("div", _hoisted_437, [
                            _createVNode("span", null, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                class: "toggle",
                                onChange: _cache[70] || (_cache[70] = ($event: any) => (_ctx.OnChangeOrderConfirmation($event))),
                                checked: _ctx.product.canChangeOrderConfirmation,
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (_ctx.product.canChangeOrderConfirmation = $event))
                              }, null, 40, ["checked"]), [
                                [_vModelCheckbox, _ctx.product.canChangeOrderConfirmation]
                              ])
                            ]),
                            _createVNode("span", _hoisted_438, _toDisplayString(_ctx.$t('product.canChangeOrderConfirmation')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_439, [
                          _createVNode("div", _hoisted_440, [
                            _createVNode("span", null, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                class: "toggle",
                                checked: _ctx.product.allowMultiplePriceLists,
                                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_ctx.product.allowMultiplePriceLists = $event)),
                                onClick: _cache[73] || (_cache[73] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeMultiplePriceLists && _ctx.changeMultiplePriceLists(...args)), ["stop"]))
                              }, null, 8, ["checked"]), [
                                [_vModelCheckbox, _ctx.product.allowMultiplePriceLists]
                              ])
                            ]),
                            _createVNode("span", _hoisted_441, _toDisplayString(_ctx.$t('product.allowMultiplePriceLists')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_442, [
                          _createVNode("div", _hoisted_443, [
                            _createVNode("span", null, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                class: "toggle",
                                checked: _ctx.product.allowAssignEmployees,
                                "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (_ctx.product.allowAssignEmployees = $event)),
                                onClick: _cache[75] || (_cache[75] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeAllowAssignEmployees && _ctx.changeAllowAssignEmployees(...args)), ["stop"]))
                              }, null, 8, ["checked"]), [
                                [_vModelCheckbox, _ctx.product.allowAssignEmployees]
                              ])
                            ]),
                            _createVNode("span", _hoisted_444, _toDisplayString(_ctx.$t('employee.allowed-assign-employees')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_445, [
                          _createVNode("div", _hoisted_446, [
                            _createVNode("span", null, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                class: "toggle",
                                checked: _ctx.product.active,
                                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (_ctx.product.active = $event)),
                                onClick: _cache[77] || (_cache[77] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disactivateOrActivateProduct && _ctx.disactivateOrActivateProduct(...args)), ["stop"]))
                              }, null, 8, ["checked"]), [
                                [_vModelCheckbox, _ctx.product.active]
                              ])
                            ]),
                            _createVNode("span", _hoisted_447, _toDisplayString(_ctx.$t('product.active')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_448, [
                          _createVNode("div", _hoisted_449, [
                            _createVNode("span", _hoisted_450, _toDisplayString(_ctx.$t('product.isRegistrationRequired')), 1),
                            _createVNode(_component_Multiselect, {
                              modelValue: _ctx.product.registrationType,
                              "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.product.registrationType = $event)),
                              valueProp: "id",
                              label: "name",
                              trackBy: "name",
                              options: _ctx.registrationTypes,
                              searchable: false,
                              "close-on-select": true,
                              canDeselect: false
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_451, [
                          _createVNode("p", _hoisted_452, _toDisplayString(_ctx.$t('calendar.v3.modal.slot.title')) + ":", 1),
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.product.selectedOrderBlockOption,
                            "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.product.selectedOrderBlockOption = $event)),
                            valueProp: "id",
                            label: "name",
                            trackBy: "name",
                            options: _ctx.orderBlockOptions,
                            searchable: false,
                            "close-on-select": true,
                            canDeselect: false,
                            onInput: _ctx.watchAtOption
                          }, null, 8, ["modelValue", "options", "onInput"])
                        ]),
                        (_ctx.product.blockCreatingNewOrdersBefore)
                          ? (_openBlock(), _createBlock("div", _hoisted_453, [
                              _createVNode("div", _hoisted_454, [
                                _createVNode(_component_InputNumber, {
                                  class: [{ 'form-controll-multiselect': !_ctx.product.orderBlockMinutes }, "InputNumber-orderBlockMinutes"],
                                  required: "",
                                  modelValue: _ctx.product.orderBlockMinutes,
                                  "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (_ctx.product.orderBlockMinutes = $event)),
                                  min: 0,
                                  allowEmpty: true
                                }, null, 8, ["class", "modelValue"]),
                                _createVNode("div", _hoisted_455, [
                                  _createVNode(_component_Multiselect, {
                                    modelValue: _ctx.product.selectedOrderBlockType,
                                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_ctx.product.selectedOrderBlockType = $event)),
                                    valueProp: "id",
                                    label: "name",
                                    trackBy: "name",
                                    options: _ctx.orderBlockTypes,
                                    searchable: false,
                                    "close-on-select": true,
                                    canDeselect: false,
                                    onChange: _cache[82] || (_cache[82] = ($event: any) => (_ctx.product.orderBlockMinutes = null))
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_456,
                        _createVNode("div", _hoisted_457, [
                          _createVNode("div", _hoisted_458, [
                            _createVNode("div", _hoisted_459, [
                              _withDirectives(_createVNode("input", {
                                required: "",
                                "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => (_ctx.product.pricePerPerson = $event)),
                                class: "inp-cbx2",
                                style: {"display":"none"},
                                type: "radio",
                                name: "priceType",
                                id: "priceTypePerson",
                                value: true
                              }, null, 512), [
                                [_vModelRadio, _ctx.product.pricePerPerson]
                              ]),
                              _createVNode("label", _hoisted_460, [
                                _hoisted_461,
                                _createVNode("span", _hoisted_462, _toDisplayString(_ctx.$t('product.pricePerPerson')), 1)
                              ]),
                              _createVNode("small", _hoisted_463, _toDisplayString(_ctx.$t('product.forExampleTicketForAFoodTour')), 1)
                            ]),
                            _createVNode("div", _hoisted_464, [
                              _withDirectives(_createVNode("input", {
                                required: "",
                                "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => (_ctx.product.pricePerPerson = $event)),
                                class: "inp-cbx2",
                                style: {"display":"none"},
                                type: "radio",
                                name: "priceType",
                                id: "priceTypeUnit",
                                value: false
                              }, null, 512), [
                                [_vModelRadio, _ctx.product.pricePerPerson]
                              ]),
                              _createVNode("label", _hoisted_465, [
                                _hoisted_466,
                                _createVNode("span", _hoisted_467, _toDisplayString(_ctx.$t('product.pricePerUnit')), 1)
                              ]),
                              _createVNode("small", _hoisted_468, _toDisplayString(_ctx.$t('product.forExamplePriceForAJeep')), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_469, [
                  _createVNode("div", _hoisted_470, [
                    _createVNode("h5", _hoisted_471, [
                      _createVNode("button", _hoisted_472, _toDisplayString(_ctx.$t('product.about-responsible-person')), 1),
                      _hoisted_473
                    ])
                  ]),
                  _createVNode("div", _hoisted_474, [
                    _createVNode("div", _hoisted_475, [
                      _createVNode("div", _hoisted_476, [
                        _createVNode("div", _hoisted_477, [
                          _createVNode("input", {
                            type: "file",
                            name: "",
                            id: "reponsible-person-image-upload-input",
                            style: {"display":"none"},
                            onChange: _cache[85] || (_cache[85] = ($event: any) => (_ctx.uploadingImageValidation($event, true))),
                            accept: "image/*"
                          }, null, 32),
                          (_ctx.product.responsiblePersonPhotoUrl)
                            ? (_openBlock(), _createBlock("div", _hoisted_478, [
                                _createVNode("img", {
                                  width: "144",
                                  height: "144",
                                  src: _ctx.product.responsiblePersonPhotoUrl,
                                  class: "about-me-round-image"
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_479, [
                                  _createVNode("span", {
                                    class: "text-link",
                                    onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.uploadFile($event, 'reponsible-person-image-upload-input')))
                                  }, _toDisplayString(_ctx.$t('about-responsible-person.edit-photo')), 1),
                                  _createVNode("span", {
                                    class: "text-link",
                                    onClick: _cache[87] || (_cache[87] = 
//@ts-ignore
(...args) => (_ctx.removeResponsiblePersonImage && _ctx.removeResponsiblePersonImage(...args)))
                                  }, _toDisplayString(_ctx.$t('about-responsible-person.delete-photo')), 1)
                                ])
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_480, [
                                _hoisted_481,
                                _createVNode("span", {
                                  onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.uploadFile($event, 'reponsible-person-image-upload-input'))),
                                  class: "text-link"
                                }, _toDisplayString(_ctx.$t('about-responsible-person.upload-photo')), 1)
                              ])),
                          _createVNode("div", _hoisted_482, [
                            _createVNode("div", _hoisted_483, [
                              (_ctx.responsiblePersonImgSrc)
                                ? (_openBlock(), _createBlock("div", _hoisted_484, [
                                    _createVNode(_component_cropper, {
                                      ref: "circleCropperLib",
                                      class: "cropper",
                                      src: _ctx.responsiblePersonImgSrc,
                                      "stencil-component": _ctx.circleStencil,
                                      "stencil-props": {
                                aspectRatio: 1,
                                lines: {
                                  north: false,
                                  west: false,
                                  south: false,
                                  east: false,
                                },
                                previewClass: 'circle-preview',
                              }
                                    }, null, 8, ["src", "stencil-component"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.responsiblePersonImgSrc)
                                ? (_openBlock(), _createBlock("div", _hoisted_485, [
                                    _createVNode("div", _hoisted_486, [
                                      _createVNode("div", _hoisted_487, [
                                        _createVNode("div", _hoisted_488, [
                                          _createVNode("button", {
                                            type: "button",
                                            class: "btn save-image-btn browse-photo green-button mt-4",
                                            onClick: _cache[89] || (_cache[89] = 
//@ts-ignore
(...args) => (_ctx.saveResponsiblePersonImage && _ctx.saveResponsiblePersonImage(...args)))
                                          }, _toDisplayString(_ctx.$t('button.save')), 1)
                                        ]),
                                        _createVNode("div", _hoisted_489, [
                                          _createVNode("button", {
                                            type: "button",
                                            class: "clear-image-btn btn browse-photo gray-button mt-4",
                                            onClick: _cache[90] || (_cache[90] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                                          }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_490, [
                              _createVNode("div", _hoisted_491, [
                                _createVNode("span", _hoisted_492, _toDisplayString(_ctx.$t('about-responsible-person.full-name')) + ":", 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                maxlength: "30",
                                class: "bookit-input product-input form-control h48",
                                placeholder: _ctx.$t('about-responsible-person.placeholder.full-name'),
                                "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.product.responsiblePersonName = $event))
                              }, null, 8, ["placeholder"]), [
                                [
                                  _vModelText,
                                  _ctx.product.responsiblePersonName,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _createVNode("span", _hoisted_493, [
                                (_ctx.product.responsiblePersonName)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      class: { 'length-limit': _ctx.product.responsiblePersonName.length > 29 }
                                    }, _toDisplayString(_ctx.product.responsiblePersonName.length), 3))
                                  : (_openBlock(), _createBlock("span", _hoisted_494, "0")),
                                _hoisted_495
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_496, [
                            _createVNode("div", _hoisted_497, [
                              _createVNode("span", _hoisted_498, _toDisplayString(_ctx.$t('about-responsible-person.description')) + ":", 1),
                              _createVNode("span", {
                                class: "pop-up-button",
                                onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.routeToEdit('responsible-person-description')))
                              }, [
                                _hoisted_499
                              ])
                            ]),
                            _withDirectives(_createVNode("textarea", {
                              name: "textArea",
                              id: "fullDescription",
                              class: "bookit-textarea product-textarea resize-off long-description form-control",
                              placeholder: _ctx.$t('about-responsible-person.placeholder.description'),
                              "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => (_ctx.product.responsiblePersonDescription = $event)),
                              maxlength: "1200"
                            }, "\n                        ", 8, ["placeholder"]), [
                              [
                                _vModelText,
                                _ctx.product.responsiblePersonDescription,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createVNode("span", _hoisted_500, [
                              (_ctx.product.responsiblePersonDescription)
                                ? (_openBlock(), _createBlock("span", {
                                    key: 0,
                                    class: { 'length-limit': _ctx.product.responsiblePersonDescription.length > 1199 }
                                  }, _toDisplayString(_ctx.product.responsiblePersonDescription.length), 3))
                                : (_openBlock(), _createBlock("span", _hoisted_501, "0")),
                              _hoisted_502
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_503, [
                  _createVNode("div", _hoisted_504, [
                    _createVNode("h5", _hoisted_505, [
                      _createVNode("button", _hoisted_506, _toDisplayString(_ctx.$t('product.selling-settings.name')), 1),
                      _hoisted_507
                    ])
                  ]),
                  _createVNode("div", _hoisted_508, [
                    _createVNode("div", _hoisted_509, [
                      _createVNode("div", _hoisted_510, [
                        _createVNode(_component_ProductSellingSettings, {
                          editMode: true,
                          productId: _ctx.id,
                          useCashierProp: _ctx.product.useCashier,
                          useLocalsProp: _ctx.product.useLocals,
                          useGroupsProp: _ctx.product.useGroups,
                          useB2cChannelsProp: _ctx.product.useB2cChannels,
                          useIndexProp: _ctx.product.useIndex,
                          printingTypeProp: _ctx.product.printingType,
                          onChangeSellingSetting: _ctx.changeSellingSetting,
                          onChangeSellingSettingPrintingType: _ctx.changeSellingSettingPrintingType
                        }, null, 8, ["productId", "useCashierProp", "useLocalsProp", "useGroupsProp", "useB2cChannelsProp", "useIndexProp", "printingTypeProp", "onChangeSellingSetting", "onChangeSellingSettingPrintingType"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_511, [
            _createVNode("button", {
              class: "arrow-button",
              onClick: _cache[94] || (_cache[94] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
              type: "button"
            }, [
              _hoisted_512
            ]),
            _createVNode("div", _hoisted_513, [
              _createVNode("div", _hoisted_514, [
                _createVNode(_component_router_link, {
                  to: { name: 'edit-product', params: { id: _ctx.id } }
                }, {
                  default: _withId(() => [
                    _createVNode("button", _hoisted_515, [
                      _hoisted_516,
                      _createVNode("p", null, _toDisplayString(_ctx.$t('button.edit')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          (_ctx.background)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "edit-document-background",
                onClick: _cache[95] || (_cache[95] = 
//@ts-ignore
(...args) => (_ctx.hideSettings && _ctx.hideSettings(...args)))
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_517, [
            _createVNode("button", {
              class: "arrow-button",
              onClick: _cache[96] || (_cache[96] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
              type: "button"
            }, [
              _hoisted_518
            ]),
            _createVNode("div", _hoisted_519, [
              _createVNode("div", _hoisted_520, [
                _createVNode(_component_router_link, {
                  to: { name: 'product', params: { id: _ctx.id } }
                }, {
                  default: _withId(() => [
                    _createVNode("button", _hoisted_521, _toDisplayString(_ctx.$t('button.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createVNode("div", _hoisted_522, [
                _createVNode("button", _hoisted_523, [
                  _hoisted_524,
                  _createVNode("p", null, _toDisplayString(_ctx.$t('button.save')), 1)
                ], 512)
              ])
            ])
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
})